import {Component} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MaskService} from '../../../core/utils/mask.service';

@Component({
  templateUrl: './form-input.component.html'
})

export class FormInputComponent {
  config;
  grupo: FormGroup;

  mask;
  size = 1;

  constructor(private _mask: MaskService) {
    this.mask = _mask;
  }
}
